export const getSyllabusLinkForExam = (exam: string): string => {
    switch (exam) {
        case 'design_and_pricing':
            return 'https://www.soa.org/49b405/globalassets/assets/files/edu/2025/fall/syllabi/2025-11-gh-101-syllabus.pdf'
        case 'valuation_and_regulation':
            return 'https://www.soa.org/49b549/globalassets/assets/files/edu/2025/fall/syllabi/2025-11-gh-201u-syllabus.pdf'
        case 'risk_mitigation':
            return 'https://www.soa.org/49b3f4/globalassets/assets/files/edu/2025/fall/syllabi/2025-11-gh-301-syllabus.pdf'
        case 'cp_321':
            return 'https://www.soa.org/49ae2b/globalassets/assets/files/edu/2025/fall/syllabi/2025-11-cp-321-syllabus.pdf'
        case 'individual_life_and_annuity':
            return 'https://www.soa.org/49ae29/globalassets/assets/files/edu/2025/fall/syllabi/2025-11-ila-101-syllabus.pdf'
        default:
            throw new Error(`Unknown exam: ${exam}`)
    }
}

export const getCourseStrategyGuideLinkForExam = (exam: string): string => {
    switch (exam) {
        case 'design_and_pricing':
            return 'https://www.soa.org/49ae2a/globalassets/assets/files/edu/2025/fall/strat-guide/2025-11-gh-101-strat-guide.pdf'
        case 'valuation_and_regulation':
            return 'https://www.soa.org/49ae2a/globalassets/assets/files/edu/2025/fall/strat-guide/2025-11-gh-201u-strat-guide.pdf'
        case 'risk_mitigation':
            return 'https://www.soa.org/49ae2a/globalassets/assets/files/edu/2025/fall/strat-guide/2025-11-gh-301-strat-guide.pdf'
        case 'cp_321':
            return 'https://www.soa.org/49ae2a/globalassets/assets/files/edu/2025/fall/strat-guide/2025-11-cp-321-strat-guide.pdf'
        case 'individual_life_and_annuity':
            return 'https://www.soa.org/49ae2a/globalassets/assets/files/edu/2025/fall/strat-guide/2025-11-ila-101-strat-guide.pdf'
        default:
            throw new Error(`Unknown exam: ${exam}`)
    }
}

export const getIntroductoryStudyNoteLinkForExam = (exam: string): string => {
    switch (exam) {
        case 'design_and_pricing':
            return 'https://www.soa.org/49ae2b/globalassets/assets/files/edu/2025/fall/intro-notes/2025-11-gh-101-intro-note.pdf'
        case 'valuation_and_regulation':
            return 'https://www.soa.org/49ae2b/globalassets/assets/files/edu/2025/fall/intro-notes/2025-11-gh-201u-intro-note.pdf'
        case 'risk_mitigation':
            return 'https://www.soa.org/49ae2b/globalassets/assets/files/edu/2025/fall/intro-notes/2025-11-gh-301-intro-note.pdf'
        case 'cp_321':
            return 'https://www.soa.org/49ae2b/globalassets/assets/files/edu/2025/fall/intro-notes/2025-11-cp-321-intro-note.pdf'
        case 'individual_life_and_annuity':
            return 'https://www.soa.org/49ae28/globalassets/assets/files/edu/2025/fall/intro-notes/2025-11-ila-101-intro-note.pdf'
        default:
            throw new Error(`Unknown exam: ${exam}`)
    }
}
